import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { FolderSimple, Trash, ArrowUpRight } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/projects");
      setProjects(data.projects || []);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    if (!confirm("¿Eliminar este proyecto?")) return;
    await api.delete(`/projects/${id}`);
    toast.success("Eliminado");
    load();
  };

  return (
    <div className="h-full overflow-auto px-10 py-10">
      <div className="max-w-5xl">
        <p className="label-micro text-[#FF9800] mb-2">PROYECTOS</p>
        <h1 className="text-4xl font-bold tracking-tight">Mis análisis guardados</h1>
        <p className="text-white/50 text-sm mt-2 max-w-xl">
          Cada proyecto guarda zonificación, orígenes, destinos, fecha y filtros para
          poder reproducir o iterar tu análisis.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="projects-list">
          {loading && <p className="text-white/40 text-sm col-span-full">Cargando…</p>}
          {!loading && projects.length === 0 && (
            <div className="border border-dashed border-white/10 p-10 text-center col-span-full">
              <FolderSimple size={32} className="text-white/30 mx-auto mb-3" />
              <p className="text-white/50 text-sm mb-4">No has guardado proyectos todavía.</p>
              <Link to="/analisis">
                <Button className="rounded-none bg-[#FF9800] text-black hover:bg-[#FFA726]">
                  Crear el primero
                </Button>
              </Link>
            </div>
          )}
          {projects.map((p) => (
            <div key={p.id} className="border border-white/10 bg-[#121212] p-4 group hover:border-[#FF9800] transition-colors">
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                    {p.config?.level || "—"}
                  </p>
                  <h3 className="font-bold text-lg mt-1 truncate" title={p.name}>{p.name}</h3>
                </div>
                <button onClick={() => remove(p.id)} className="text-white/30 hover:text-[#F44336] p-1" data-testid={`delete-project-${p.id}`}>
                  <Trash size={16} />
                </button>
              </div>
              <p className="text-xs text-white/50 mt-3 font-mono">
                {p.config?.origins?.length || 0} orígenes · {p.config?.destinations?.length || 0} destinos
              </p>
              <p className="text-xs text-white/40 mt-1 font-mono">{p.config?.date || "—"}</p>
              <p className="text-xs text-white/40 mt-3 line-clamp-2">{p.description}</p>
              <Link
                to="/analisis"
                state={{ project: p }}
                className="mt-4 inline-flex items-center gap-1 text-[#00E5FF] text-xs hover:underline"
              >
                Abrir <ArrowUpRight size={12} weight="bold" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
